module.exports = __webpack_public_path__ + "src/assets/img/logon.fa8e5933.svg";